var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "abbr",
    { ref: "tooltip", staticClass: "ml-2", attrs: { title: _vm.infoText } },
    [
      _c("InfoIcon", {
        attrs: { classes: "svg-icon icon-tooltip svg-icon--small@large" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }